module.exports = __webpack_public_path__ + "static/media/logo.d050214a.png";